<template>
  <v-container grid-list-xs>
    <v-row justify="center">
      <v-col cols="12" md="8" lg="9">
        <v-data-table
          :items="ChargeList"
          :loading="loading"
          :headers="headers"
          :items-per-page="10"
          class="elevation-12"
        >
          <template v-slot:[`item.ChargeDate`]="{ item }">
            {{ item.ChargeDate }}
          </template>
          <template v-slot:[`item.TotalAmount`]="{ item }">
            {{ item.Amount && item.Amount.toLocaleString() }}
          </template>
          <template v-slot:[`item.Ref`]="{ item }">
            <BaseDelete
              :DelQuery="{ Ref: item.Ref }"
              DelUrl="/charge/Remove"
              :OnFinish="
                () => {
                  ChargeList = ChargeList.filter(chr => chr._id != item._id);
                }
              "
            >
              <template v-slot:title>
                {{ item.Gargeyear }}/{{ item.Gargemonth }}
              </template>
              <template v-slot:DeleteBtn>
                <v-btn icon color="error">
                  <v-icon small>fas fa-trash-alt</v-icon>
                </v-btn>
              </template>
              <h3 class="text-center">
                <p class="error--text">
                  Expense Date:
                  <span class="black--text"
                    >{{ item.Gargeyear }}/{{ item.Gargemonth }}</span
                  >
                </p>
                <v-divider class="mb-5"></v-divider>
                <small class="error--text mt-5">
                  Charged Date: {{ item.ChargeDate }}
                </small>
              </h3>
            </BaseDelete>
          </template>
        </v-data-table>
      </v-col>
      <v-col col="12" md="4" lg="3">
        <v-card class="elevation-12">
          <v-toolbar dark color="teal darken">
            <v-toolbar-title>Charging Form</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="CharginForm">
              <BaseDate
                v-model="ChargeEntryDate"
                outlined
                :rules="v => !!v || 'Date is required'"
              >
              </BaseDate>
              <v-text-field
                outlined
                type="number"
                v-model.number.trim="GargingYear"
                :rules="[rules.required]"
                shaped
                label="Year"
                id="YearID"
              ></v-text-field>
              <v-select
                outlined
                shaped
                :rules="[rules.required]"
                :items="Months"
                v-model.trim="GargingMonth"
                label="Charging Month"
              ></v-select>

              <p
                class="font-weight-black mt-3 text-center"
                v-html="msgError"
              ></p>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              block
              @click="OnChargeSave"
              :loading="clicked"
              class="elevation-6"
              rounded
              color="teal darken-2"
              dark
              width="150"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      msgError: "",
      clicked: false,
      GargingMonth: "",
      GargingYear: "",
      ChargeEntryDate: "",
      Months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "Septemper",
        "October",
        "November",
        "December",
      ],
      ChargeList: [],
      headers: [
        {
          text: "Date",
          align: "left",
          value: "ChargeDate",
          class: "teal darken-1 white--text",
        },
        {
          text: "Year",
          value: "Gargeyear",
          class: "teal darken-1 white--text",
        },
        {
          text: "Month",
          value: "Gargemonth",
          class: "teal darken-1 white--text",
        },
        {
          text: "Amount",
          value: "TotalAmount",
          class: "teal darken-1 white--text",
        },
        // {
        //   text: "Clients",
        //   value: "TotalClients",
        //   class: "teal darken-1 white--text"
        // },
        // { text: "Building", value: "HouseName" },
        { text: "Ref", value: "Ref", class: "teal darken-1 white--text" },
      ],
      rules: {
        required: value => !!value || "Required.",
      },
    };
  },
  methods: {
    getReq(url) {
      //   apartments
      return this.$store.dispatch("GET_ONLY", url);
    },
    PostReq(url) {
      //   apartments
      return this.$store.dispatch("INSERT_ONLY", {
        url,
        data: {
          Gargemonth: this.GargingMonth,
          Gargeyear: this.GargingYear,
          ChargeDate: this.ChargeEntryDate,
        },
      });
    },
    loadCharche() {
      let currentDate = new Date();
      this.GargingYear = currentDate.getFullYear();
      this.loading = true;
      this.getReq(`/charge`)
        .then(result => {
          // console.log(result);
          this.loading = false;
          this.ChargeList = result.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    OnChargeSave() {
      this.msgError = "";
      if (this.$refs.CharginForm.validate()) {
        this.loading = true;
        this.clicked = true;
        this.PostReq("/charge")
          .then(() => {
            this.loading = false;
            this.clicked = false;
            this.GargingMonth = null;
            this.ChargeEntryDate = null;
            this.ChargeEntryDate = this.Current().date;
            this.$refs.CharginForm.resetValidation();
            this.loadCharche();
            // console.log(result);
            // this.ChargeList = result.data;
            // let currentDate = new Date();
            // this.GargingYear = currentDate.getFullYear();
          })
          .catch(err => {
            this.loading = false;
            this.clicked = false;
            this.msgError = err.response.data;
            // console.log(err);
          });
      }
    },
  },
  mounted() {
    this.loadCharche();
    this.ChargeEntryDate = this.Current().date;
  },
};
</script>
<style lang="scss" scoped>
.table-header {
  thead {
    background-color: black;
  }
}
</style>
